import { Component, OnInit } from '@angular/core';
import { AdmihairBaseComponent } from '../../admihair-base.component';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { Administradora } from 'src/app/admihair/api/dto/administradora';
import { SelectItem } from 'primeng/api';
import { MunicipioService } from 'src/app/admihair/service/municipio.service';
import { UfService } from 'src/app/admihair/service/uf.service';
import { Uf } from 'src/app/admihair/api/dto/uf';
import { AdministradoraService } from 'src/app/admihair/service/administradora.service';
import { Municipio } from 'src/app/admihair/api/dto/municipio';

@Component({
  selector: 'app-dados-franquia',
  templateUrl: './dados-franquia.component.html',
  styleUrls: ['./dados-franquia.component.scss']
})
export class DadosFranquiaComponent extends AdmihairBaseComponent implements OnInit {

  imageChangedEvent: any = '';
  croppedImage: any = '';
  defaultImage: string = 'assets/demo/images/avatar/logo_default.jpg';
  mostrarDialogImagem: boolean = false;

  loading: boolean = false;

  franquia?: Administradora;
  editar: boolean = false;

  listaUfs: SelectItem[] = [];
  listaMunicipios: SelectItem[] = [];

  progressoRequisicao: boolean = false;



  constructor(private administradoraService: AdministradoraService,
    private municipioService: MunicipioService,
    private ufService: UfService,
    erroService: ErroService,
    utilStorageService: UtilStorageService
  ) { super(erroService, utilStorageService) }

  ngOnInit(): void {
    this.loading = true;
    this.carregarUfs();
    this.permissaoListar = this.verificarPermissao('PERM_CONFIGURACAO_FRANQUIA')
    this.franquia = this.getAdministradora();
    
  }

  editarDados() {
    this.editar = true;
    // this.renderer.selectRootElement('#campoEmail').focus();
    // this.carregarUfs();
  }


  atualizar() {

  }


  carregarUfs() {
    this.ufService.listarUf().subscribe({
      next: (data: Uf[]) => {
        this.listaUfs = data.map(uf => ({ label: uf.siglaUf, value: uf.codigoUf }));
        this.loading = false;;
      },
      error: (err: any) => {
        this.exibirMensagemErro(err);
      }
    }
    )
  }


  carregarMunicipios(mudarUf?: boolean) {
    const codigoUf = this.listaUfs.find(uf => uf.label === this.franquia?.uf)?.value;
    if (mudarUf && this.franquia?.cidade) {
      this.franquia.cidade = undefined;
    }
    this.municipioService.listarMuniciosPorUf(codigoUf).subscribe({
      next: (data: Municipio[]) => {
        this.listaMunicipios = data.map(m => ({ label: m.descricao, value: m.codigoIbge }));
      },
      error: (err: any) => {
        this.exibirMensagemErro(err);
      }
    }
    )
  }

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
    this.mostrarDialogImagem = true;
  }


}
